import React, { useMemo, useState } from 'react';

import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import { isMobile } from 'react-device-detect';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckIcon from '@mui/icons-material/Check';

import { displayError } from '../../../helpers';
import { InfoIcon } from '../../../components/Icons';
import { donationActions } from '../../../store/actions';
import { useNonInitialEffect } from '../../../hooks/UseNonInitialEffect';
import { LightTooltip } from '../../../components/StyledComponents/LightToolTip';
import { CheckboxWithLabel, GoalAmountInput, SwitchWithLabel, Textfield } from '../../../components';
import { DONATION_IMPACT_TYPES, SINGLE_OWNER_PAGE, TEAM_PAGE } from '../../../constants';
import { Alert, AlertTitle } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function ({ state, handleChange, editView, validationErrors }) {
	const dispatch = useDispatch();
	const [openTooltip, setOpenTooltip] = useState(false);

	return (
		<Stack gap={3} className="BasicInfoTab">
			<Textfield
				name="name"
				label="Give your page a name"
				value={state.name}
				onChange={handleChange}
				error={displayError(validationErrors?.name)}
				helperText={validationErrors.name}
				required
				autoFocus
				fullWidth
			/>
			<FormControl>
				<FormLabel>
					<Typography className="FundraiserTypeLabel">I am fundraising ...</Typography>
				</FormLabel>
				<Stack gap={4}>
					<RadioGroup name="pageType" value={state.pageType} onChange={(e) => handleChange(e)}>
						<Stack className="FundraiserTypeStack" direction={{ xs: 'column', md: 'row' }} spacing={{}}>
							<Box
								className={`TypeOption ${state.pageType === SINGLE_OWNER_PAGE ? 'selected' : ''}`}
								onClick={() => handleChange({ target: { name: 'pageType', value: SINGLE_OWNER_PAGE } })}
							>
								{state.pageType === SINGLE_OWNER_PAGE && (
									<Box className="SelectedCheckCircle">
										<CheckIcon fontSize="inherit" />
									</Box>
								)}
								<Typography className="TypeOptionTitle">as an individual</Typography>
								<Typography className="DescItem">I will raise funds on my own</Typography>
								<Radio className="HiddenRadio" size="small" value={SINGLE_OWNER_PAGE} checked={state.pageType === SINGLE_OWNER_PAGE} />
							</Box>
							<Box
								className={`TypeOption ${state.pageType === TEAM_PAGE ? 'selected' : ''}`}
								onClick={() => handleChange({ target: { name: 'pageType', value: TEAM_PAGE } })}
							>
								{state.pageType === TEAM_PAGE && (
									<Box className="SelectedCheckCircle">
										<CheckIcon fontSize="inherit" />
									</Box>
								)}
								<Typography className="TypeOptionTitle">in a team</Typography>
								<Typography className="DescItem">I will invite friends to raise funds with me</Typography>
								<Radio className="HiddenRadio" size="small" value={TEAM_PAGE} checked={state.pageType === TEAM_PAGE} />
							</Box>
						</Stack>
					</RadioGroup>
					<Alert severity="info" icon={<InfoOutlinedIcon fontSize="inherit" />} sx={{ borderRadius: '8px' }}>
						Team fundraising can be enabled later.
					</Alert>
				</Stack>
			</FormControl>

			<Stack className="KeepPagePrivateStack" direction="row" alignItems="center">
				<CheckboxWithLabel nameAndId={'keepPagePrivate'} label={'Keep my page private'} handleCheck={(e) => handleChange(e)} />
				<LightTooltip
					popperSx={{ marginTop: isMobile ? '0' : undefined }}
					open={isMobile ? openTooltip : undefined}
					onClick={() => setOpenTooltip(!openTooltip)}
					title="Private fundraisers will not appear in search results but will be accessible through direct links."
					placement={isMobile ? 'bottom' : 'right'}
				>
					<IconButton>
						<InfoIcon />
					</IconButton>
				</LightTooltip>
			</Stack>
		</Stack>
	);
}
